import { useState } from 'react';

import Header from '../Component/Header';
import Footer from '../Component/Footer';
import Meetupsdtlbannersec from "../Components/Meetupsdtlbannersec";
import Meetupsdtlaboutsec from "../Components/Meetupsdtlaboutsec";
import Meetupsdtlfreesec from "../Components/Meetupsdtlfreesec";

const CommunityDtl = () => {
const [activeTab, setActiveTab] = useState('details');

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      <Header />


<main className="min-h-screen bg-white pb-16">



<Meetupsdtlbannersec />


<div className="container mx-auto px-4">
  <div className="mt-10 grid gap-8 md:grid-cols-3 lg:gap-12">
    {/* Main Content Area (Left side) */}
    
    <Meetupsdtlaboutsec />
     
    {/* Join and Stats Section */}
    <Meetupsdtlfreesec />
    
  </div>
</div>




</main>



      <Footer />
    </>
  );
};

export default CommunityDtl;
